import React from "react";
import "../../css/terms.scss";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

const Legal = () => {
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div>
      <Header />

      <main className="terms-main legal-page">
        <section className="hero-inner content-width-xlg">
          <h1 className="title">Legal</h1>

          <div className="body-text large-concise-body-text modify-text">
            <p>
              Here you’ll find some of the key legal terms and policies that
              help guide how GoFundMe works. We’ve put them all in one place so
              it’s easy to understand your rights and responsibilities, the
              rules that keep our community safe, and the terms that apply when
              interacting with our services, software, and platform.
            </p>

            <p>
              This isn’t a complete list of every legal document, but it covers
              the most important ones that apply when you use our platform. If
              you’re looking for something specific and don’t see it here, feel
              free to contact us.
            </p>
          </div>
        </section>

        <section className="legal-cards content-width-xlg">
          <Link to="/terms" onClick={toTop} className="legal-card">
            <div className="card-icon" aria-hidden="true">
              <img alt="" src="main/le1-1.svg" />
            </div>
            <h3>Donors, Organizers, and Beneficiaries</h3>
            <div className="card-arrow" aria-hidden="true">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 12h14M13 5l6 7-6 7"
                  stroke="#9b9b9b"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </Link>

          <Link to="/privacy" onClick={toTop} className="legal-card">
            <div className="card-icon" aria-hidden="true">
              <img alt="" src="main/le1-2.svg" />
            </div>
            <h3>Nonprofit Organizations</h3>
            <div className="card-arrow" aria-hidden="true">
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 12h14M13 5l6 7-6 7"
                  stroke="#9b9b9b"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </Link>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Legal;
